/**
 * 현재 야놀자에서 금액을 표시할때는 단위가 '원' 으로 노출되는 중이다. (포인트는 'P', 코인은 'C')
 * toLocaleString 을 사용했을 때 의도하지 않은 포맷으로 금액이 노출되는 것을 방지하기 위해
 * 'ko-KR' locale parameter 로 고정시킨 함수
 */
const krNumberToString = (number: number, options?: Intl.NumberFormatOptions): string => {
  return number.toLocaleString('ko-KR', options)
}

/**
 * @param price {number} 금액
 * @param space {boolean} 금액과 단위 사이 띄어쓰기 유무
 * */
export const toKRW = (price: number, space = false) =>
  `${krNumberToString(price)}${space ? ' ' : ''}원`

/**
 * @param amount {number} 금액
 * @param space {boolean} 금액과 단위 사이 띄어쓰기 유무
 * */
export const toPoint = (amount: number, space = false) =>
  `${krNumberToString(amount)}${space ? ' ' : ''}P`

/**
 * @param amount {number} 금액
 * @param space {boolean} 금액과 단위 사이 띄어쓰기 유무
 * */
export const toCoin = (amount: number, space = false) =>
  `${krNumberToString(amount)}${space ? ' ' : ''}C`

export default krNumberToString
